import CSVReader from 'components/CSVReader/FileReader';

export default CSVReader;